import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchSetCostReportStatus } from '../services/patchSetCostReportStatus.service';

export const setCostReportStatus = createAsyncThunk(
  'expenseTracking/setCostReportStatus',
  async ({ reportPK, status }, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    const updated = await patchSetCostReportStatus(selectedProjectId, {
      reportPK,
      status,
    });

    return updated;
  }
);
